import {
  DASHBOARD_COUNT_REQ,
  DASHBOARD_COUNT_SUCCESS,
  DASHBOARD_COUNT_ERROR,
  GET_ORDER_REQ,
  GET_ORDER_SUCCESS,
  GET_ORDER_ERROR,
  GET_ALLCUSTOMER_REQ,
  GET_ALLCUSTOMER_SUCCESS,
  GET_ALLCUSTOMER_ERROR,
  ALLOW_CUSTOMER_REQ,
  ALLOW_CUSTOMER_SUCCESS,
  ALLOW_CUSTOMER_ERROR,
  RESTRICT_CUSTOMER_REQ,
  RESTRICT_CUSTOMER_SUCCESS,
  RESTRICT_CUSTOMER_ERROR,
  GET_ORDER_BY_ID_REQ,
  GET_ORDER_BY_ID_SUCCESS,
  GET_ORDER_BY_ID_ERROR,
  ORDER_APPROVAL_REQ,
  ORDER_APPROVAL_SUCCESS,
  ORDER_APPROVAL_ERROR,
  DELETE_DOC_REQ,
  DELETE_DOC_SUCCESS,
  DELETE_DOC_ERROR,
  UPLOAD_DOC_ERROR,
  UPLOAD_DOC_SUCCESS,
  UPLOAD_DOC_REQ,
  GET_NOTIFICATION_REQ,
  GET_NOTIFICATION_SUCCESS,
  GET_NOTIFICATION_ERROR,
  IS_READ_REQ,
  IS_READ_SUCCESS,
  IS_READ_ERROR,
  GET_LOGISTICS_REQ,
  GET_LOGISTICS_SUCCESS,
  GET_LOGISTICS_ERROR,
  GET_LOG_PARTNER_REQ,
  GET_LOG_PARTNER_SUCCESS,
  GET_LOG_PARTNER_ERROR,
  MARK_AS_FAV_REQ,
  MARK_AS_FAV_SUCCESS,
  MARK_AS_FAV_ERROR,
  GET_RMX_COMPANIES_REQ,
  GET_RMX_COMPANIES_SUCCESS,
  GET_RMX_COMPANIES_ERROR,
} from "../constants";
export default class DashboardAction {
  static getCountReq(params) {
    return {
      type: DASHBOARD_COUNT_REQ,
      params,
    };
  }
  static getCountSuccess(payload) {
    return {
      type: DASHBOARD_COUNT_SUCCESS,
      payload,
    };
  }
  static getCountError(error) {
    return {
      type: DASHBOARD_COUNT_ERROR,
      error,
    };
  }
  static getOrderReq(id, params) {
    return {
      type: GET_ORDER_REQ,
      params,
      id,
    };
  }
  static getOrderSuccess(payload, metaData) {
    return {
      type: GET_ORDER_SUCCESS,
      payload,
      metaData,
    };
  }
  static getOrderError(error) {
    return {
      type: GET_ORDER_ERROR,
      error,
    };
  }
  static getAllCustomerReq(params) {
    return {
      type: GET_ALLCUSTOMER_REQ,
      params,
    };
  }
  static getAllCustomerSuccess(payload, metaData) {
    return {
      type: GET_ALLCUSTOMER_SUCCESS,
      payload,
      metaData,
    };
  }
  static getAllCustomerError(error) {
    return {
      type: GET_ALLCUSTOMER_ERROR,
      error,
    };
  }
  static allowCustomerReq(params, cb, payload) {
    return {
      type: ALLOW_CUSTOMER_REQ,
      params,
      cb,
      payload,
    };
  }

  static allowCustomerSuccess(payload) {
    return {
      type: ALLOW_CUSTOMER_SUCCESS,
      payload,
    };
  }
  static allowCustomerError(error) {
    return {
      type: ALLOW_CUSTOMER_ERROR,
      error,
    };
  }

  static restrictCustomerReq(params, cb, payload) {
    return {
      type: RESTRICT_CUSTOMER_REQ,
      params,
      cb,
      payload,
    };
  }

  static restrictCustomerSuccess(payload) {
    return {
      type: RESTRICT_CUSTOMER_SUCCESS,
      payload,
    };
  }
  static restrictCustomerError(error) {
    return {
      type: RESTRICT_CUSTOMER_ERROR,
      error,
    };
  }

  static getOrderDetailReq(id, cb) {
    return {
      type: GET_ORDER_BY_ID_REQ,
      id,
      cb,
    };
  }

  static getOrderDetailSuccess(payload) {
    return {
      type: GET_ORDER_BY_ID_SUCCESS,
      payload,
    };
  }
  static getOrderDetailError(error) {
    return {
      type: GET_ORDER_BY_ID_ERROR,
      error,
    };
  }

  static OrderApprovalReq(id, cb, params, logId) {
    return {
      type: ORDER_APPROVAL_REQ,
      id,
      cb,
      params,
      logId,
    };
  }

  static OrderApprovalSuccess(payload) {
    return {
      type: ORDER_APPROVAL_SUCCESS,
      payload,
    };
  }
  static OrderApprovalError(error) {
    return {
      type: ORDER_APPROVAL_ERROR,
      error,
    };
  }

  static deleteDocReq(orderId, docId, cb) {
    return {
      type: DELETE_DOC_REQ,
      orderId,
      docId,
      cb,
    };
  }

  static deleteDocSuccess(payload) {
    return {
      type: DELETE_DOC_SUCCESS,
      payload,
    };
  }
  static deleteDocError(error) {
    return {
      type: DELETE_DOC_ERROR,
      error,
    };
  }

  static uploadDocReq(orderId, payload, cb) {
    return {
      type: UPLOAD_DOC_REQ,
      orderId,
      payload,
      cb,
    };
  }

  static uploadDocSuccess(payload) {
    return {
      type: UPLOAD_DOC_SUCCESS,
      payload,
    };
  }
  static uploadDocError(error) {
    return {
      type: UPLOAD_DOC_ERROR,
      error,
    };
  }

  static getNotificationReq() {
    return {
      type: GET_NOTIFICATION_REQ,
    };
  }

  static getNotificationSuccess(payload) {
    return {
      type: GET_NOTIFICATION_SUCCESS,
      payload,
    };
  }
  static getNotificationError(error) {
    return {
      type: GET_NOTIFICATION_REQ,
      error,
    };
  }

  static isMarkReadReq(notificationId) {
    return {
      type: IS_READ_REQ,
      notificationId,
    };
  }

  static isMarkReadSuccess(payload) {
    return {
      type: IS_READ_SUCCESS,
      payload,
    };
  }
  static isMarkReadError(error) {
    return {
      type: IS_READ_ERROR,
      error,
    };
  }
  static getLogisticsReq() {
    return {
      type: GET_LOGISTICS_REQ,
    };
  }

  static getLogisticsSuccess(payload) {
    return {
      type: GET_LOGISTICS_SUCCESS,
      payload,
    };
  }
  static getLogisticsError(error) {
    return {
      type: GET_LOGISTICS_ERROR,
      error,
    };
  }

  static getLogPartnerReq() {
    return {
      type: GET_LOG_PARTNER_REQ,
    };
  }

  static getLogPartnerSuccess(payload) {
    return {
      type: GET_LOG_PARTNER_SUCCESS,
      payload,
    };
  }
  static getLogPartnerError(error) {
    return {
      type: GET_LOG_PARTNER_ERROR,
      error,
    };
  }

  static markAsFavReq(id) {
    return {
      type: MARK_AS_FAV_REQ,
      id,
    };
  }

  static markAsFavSuccess(payload) {
    return {
      type: MARK_AS_FAV_SUCCESS,
      payload,
    };
  }
  static markAsFavError(error) {
    return {
      type: MARK_AS_FAV_ERROR,
      error,
    };
  }
  static getRmxCompanyReq(params) {
    return {
      type: GET_RMX_COMPANIES_REQ,
      params,
    };
  }
  static getRmxCompanySuccess(payload, metaData) {
    return {
      type: GET_RMX_COMPANIES_SUCCESS,
      payload,
      metaData,
    };
  }
  static getRmxCompanyError(error) {
    return {
      type: GET_RMX_COMPANIES_ERROR,
      error,
    };
  }
}
